import { URLParam } from "@/helpers/interfaces/URLParam.ts";
import { useLoadReservationOffer } from "@/helpers/useLoadReservationOffer.tsx";
import { useEngineStore } from "@/stores/EngineStore/EngineStore.ts";
import { useLayoutEffect, useRef } from "react";

export const useReservationOfferURLParam = () => {
  const { handleLoadReservationOfferOption } = useLoadReservationOffer();
  const setReservationOfferOptionId = useEngineStore((state) => state.setReservationOfferOptionId);
  const processedOfferRef = useRef<string | null>(null);

  // useLayoutEffect for better recognition
  useLayoutEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const reservationOfferOptionId = urlParams.get(URLParam.ReservationOffer);

    if (reservationOfferOptionId && processedOfferRef.current !== reservationOfferOptionId) {
      processedOfferRef.current = reservationOfferOptionId;
      setReservationOfferOptionId(reservationOfferOptionId);
      void handleLoadReservationOfferOption(reservationOfferOptionId);
    }

    // eslint-disable-next-line
  }, [window.location.search]);
};
